import React, { useEffect, useState } from "react";
import "./cartsummary.scss";
import { checkP, fb, fb_blue } from "../../../assets";
import {
  audiencepayment,
  audienceContactUs,
  checkAdaccount,
  getAudienceCoupons,
} from "../../../sellers_module/services/seller/api";
import { FaTrash } from "react-icons/fa"; // Import Trash Icon from react-icons
import { toast, ToastContainer } from "react-toastify";
import { Box, Button, Link, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { captureGAEvent } from "../../../sellers_module/shared/helper";
type Product = {
  _id: string;
  name: string;
  price: number;
  discount_price: number;
  audience_size: string;
};

type CartSummaryProps = {
  cart: Product[];
  removeFromCart: (productId: any) => void;
};

type CouponCode = {
  isActive?: boolean;
  label: string;
  threshold: number;
  type: "percentage" | "flat";
  value: number;
  _id: string;
  onClose?: any;
  currCouponValue?: number;
  isApplicale?: boolean;
  setCurrCoupon?: any;
  currItem?: any;
};
const CartSummary: React.FC<CartSummaryProps> = ({ cart, removeFromCart }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<string | null>(null);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [currCoupon, setCurrCoupon] = useState<CouponCode | null>(null);
  const [paymentError, setPaymentError] = useState<string | null>(null);
  const [InputAccountId, setInputAccountId] = useState<string | null>(null);
  // const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string | null>("");

  const [isValidAdAccount, setIsValidAdAccount] = useState<boolean | null>(
    null
  );

  const [accounts, setAccounts] = useState<
    { account_id: string; account_name: string }[]
  >([]);
  // Calculate total price (original price) of all items
  const total = cart.reduce((sum, item) => sum + item.discount_price, 0);
  const [coupons, setCoupons] = useState<CouponCode[]>([]);
  const [applicableCoupons, setApplicableCoupons] = useState<CouponCode[]>([]);
  useEffect(() => {
    // call coupons api
    getAudienceCoupons().then((res) => {
      if (res?.data) {
        setCoupons(res.data);
      }
    });
    const currAccounts = localStorage.getItem("accounts");
    if (currAccounts) {
      try {
        setAccounts(JSON.parse(currAccounts));
      } catch (e) {
        console.log("Error parsing accounts");
      }
    }
  }, []);
  // Calculate total discount (original price - discounted price)
  const totalDiscount = cart.reduce(
    (sum, item) => sum + (item.price - item.discount_price),
    0
  );

  // Calculate the grand total (Total - Total Discount)
  const grandTotal = total;
  const finalgrandtotal = total - totalDiscount;
  const selectedAccountId = localStorage.getItem("selectedAudienceID") || null;

  const formatAudienceSize = (size: number) => {
    if (size >= 10000000) {
      // Format as millions (10M+)
      return Math.floor(size / 1000000) + " Million"; // Millions without decimals
    } else if (size >= 100000) {
      // Format as lakhs (1L+)
      return Math.floor(size / 100000) + " Lakhs"; // Lakhs without decimals
    } else if (size >= 1000) {
      // Format as thousands (1K+)
      return Math.floor(size / 1000) + " K"; // Thousands without decimals
    } else {
      // Return the number as is
      return size.toString();
    }
  };

  const handleAdd = async (value: string) => {
    // Clear error if input is empty
    if (!value) {
      setErrorMessage(null); // Clear error message if input is empty
      return;
    }

    try {
      // Assuming this function checks if the Ad Account is valid
      const response = await checkAdaccount(value);

      if (response?.data) {
        if (!response.data.isvalid) {
          setIsValidAdAccount(false);
          setErrorMessage("The Ad Account ID is not verified.");
        } else {
          setIsValidAdAccount(true);
          localStorage.setItem("selectedAudienceID", value);
          setErrorMessage(null);
          // setErrorMessage("?verified"); // Clear error if valid
        }
      } else {
        // Handle cases where response.data is undefined or unexpected
        setErrorMessage("Unexpected error occurred.");
      }
    } catch (error: any) {
      // Handle any unexpected error in the API call
      setErrorMessage("Please type a verified business ad account ID");
    }
  };

  const apiContactUsApi = async () => {
    try {
      const data = {
        subject: "",
        message: "",
      };
      const res = await audienceContactUs(data);
      if (res.data.message) {
        toast.success(res.data.message);
        closePopup();
      } else {
        toast.error("Somthing went wrong..");
      }
      // Handle successful response
    } catch (error: any) {
      toast.error(error);
      console.error("API call error:", error);
    }
  };
  const handlePayClick = async () => {
    setIsLoading(true);
    captureGAEvent("click", "Audience_Checkout_Pay");
    const storedAccountIds = selectedAccountId;
    captureGAEvent("Audience_Purchase_Selected_AccountID", storedAccountIds);
    try {
      const data = {
        order_value: grandTotal - (currCoupon?.currCouponValue || 0),
        order_items: cart.map((item) => ({
          product_id: item._id,
          product_price: item.discount_price,
        })),
        ad_account_id: storedAccountIds,
        coupon_code: currCoupon?.label || undefined,
      };
      // Log the raw response for debugging
      const response = await audiencepayment(data);
      if (response) {
        if (response.short_url) {
          // Success case with a payment link
          setTotalAmount(finalgrandtotal);
          // removeFromCart("-1"); // Clear all items from the cart
          console.log("Payment link created:", response.short_url);
          window.location.href = response.short_url;
          setPaymentStatus("success");
        } else if (response.status === "success") {
          // API indicates success, but no payment link
          setPaymentStatus("success");
          toast.success(response.message);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          // Generic success case
          setPaymentStatus("success");
        }
      } else {
        // Handle unexpected response structure
        setPaymentStatus("failure");
        console.error("Unexpected response structure:", response);
      }
    } catch (error: any) {
      // Network or other unexpected errors
      console.error("Payment error:", error);
      setPaymentError(error?.error || "An unknown error occurred");

      setPaymentStatus("failure");
    } finally {
      setIsPopupVisible(true); // Ensure popup visibility is set regardless of the outcome
      setIsLoading(false);
    }
  };

  const closePopup = () => {
    setIsPopupVisible(false);
    setInputAccountId(null);
    setErrorMessage(null);
    setIsValidAdAccount(null);
  };

  const clearCart = () => {
    captureGAEvent("click", "Audience_Checkout_ClearAll");
    setCurrCoupon(null);
    setApplicableCoupons([]);
    removeFromCart((cart.length = 0)); // Clear all items from the cart
  };
  useEffect(() => {
    if (cart.length > 0) {
      const actualCart = cart.filter((cartProducts) => {
        if (cartProducts.discount_price !== 0) {
          return true;
        }
      });
      const newCoupons = coupons.map((couponItem) => {
        couponItem["currCouponValue"] = getCouponDiscount(couponItem);
        return couponItem;
      });
      const applicableCoupons = coupons
        .filter((couponItem: CouponCode) => {
          if (actualCart.length >= couponItem.threshold) {
            return true;
          }
        })
        .sort((a: any, b: any) => b.currCouponValue - a.currCouponValue);

      if (applicableCoupons.length > 0) {
        setApplicableCoupons(applicableCoupons.map((items: any) => items._id));
        setCurrCoupon(applicableCoupons[0]);
        setCoupons(newCoupons);
      } else {
        setApplicableCoupons([]);
        setCurrCoupon(null);
      }
    }
  }, [cart]);
  const getCouponDiscount = (coupon: CouponCode) => {
    return coupon.type == "percentage"
      ? grandTotal * (coupon.value / 100)
      : coupon.value;
  };

  return (
    <>
      <ToastContainer style={{ paddingTop: "50px" }} />
      <div className="cart-summary-container">
        <div className="cart-summary">
          <div className="cart-header">
            <h2 className="price-labels">Checkout Summary</h2>

            {/* Only show the Clear All button if there are items in the cart */}
            {cart.length > 1 && (
              <button className="clear-cart-button" onClick={clearCart}>
                <FaTrash className="clear-cart-icon" /> Clear All
              </button>
            )}
          </div>
          {(currCoupon ||
            cart.filter((cartProducts) => {
              if (cartProducts.discount_price !== 0) {
                return true;
              }
            }).length > 0) && (
            <>
              {currCoupon && (
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{
                    border: "1px solid #EAEAEF",
                    borderRadius: "12px",
                    p: 1,
                  }}
                >
                  <Stack direction={"row"} gap={1} alignItems={"baseline"}>
                    <Typography fontWeight={"bold"} variant="body2">
                      {currCoupon.label}
                    </Typography>{" "}
                    <Typography variant="body2" color={"#9B9BB8"}>
                      Applied
                    </Typography>
                  </Stack>
                  <CloseIcon
                    onClick={() => {
                      setCurrCoupon(null);
                    }}
                  />
                </Stack>
              )}

              <Stack
                sx={{
                  flexWrap: "wrap",
                  mt: 2,
                  mb: 2,
                  width: "100%",
                }}
                gap={1}
                direction={"row"}
              >
                {coupons.map((couponItem: any) => (
                  <CouponCode
                    isActive={currCoupon?._id === couponItem._id}
                    isApplicale={applicableCoupons.includes(couponItem._id)}
                    key={couponItem.id}
                    onClose={() => {
                      setCurrCoupon(null);
                    }}
                    setCurrCoupon={setCurrCoupon}
                    currItem={couponItem}
                    {...couponItem}
                  />
                ))}
              </Stack>
            </>
          )}

          <div className="price-details">
            {cart.map((item) => (
              <div key={item._id} className="product-summary">
                <div>
                  <div className="item-name">{item.name}</div>

                  <div className="item-audienceSize">
                    {item.audience_size != null
                      ? `Audience Size: ${formatAudienceSize(
                          Number(item.audience_size)
                        )}`
                      : ""}
                  </div>
                </div>

                <div
                  className="item-price"
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "20px",
                  }}
                >
                  <p className="price">
                    {item.discount_price === 0 ? (
                      <>
                        <span className="original-price">₹{item.price}</span>
                      </>
                    ) : (
                      <>
                        <span className="original-price">₹{item.price}</span>
                      </>
                    )}{" "}
                  </p>
                  ₹{item.discount_price}
                </div>
                <button
                  className="remove-button"
                  onClick={() => removeFromCart(item._id)}
                >
                  &#x2715;
                </button>
              </div>
            ))}
          </div>
          <div className="total">
            <div className="discount">
              <span>Discount</span>
              <span>- ₹{Math.abs(totalDiscount)?.toFixed(2)}</span>
            </div>
            <div className="discount">
              <span>Coupon Discount</span>
              <span>
                - ₹{Math.abs(currCoupon?.currCouponValue || 0)?.toFixed(2)}
              </span>
            </div>
            <div className="grand-total">
              <span>Grand Total</span>
              <span>
                ₹{(grandTotal - (currCoupon?.currCouponValue || 0))?.toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        <Typography variant="body2" fontWeight={"bold"} mb={1}>
          Your audience will be shared to{" "}
          {
            accounts.find(
              (currAcc: { account_id: string; account_name: string }) => {
                if (currAcc?.account_id) {
                  return currAcc?.account_id === `act_${selectedAccountId}`;
                }
              }
            )?.account_name
          }
        </Typography>
        <button
          style={{
            background: "#7f6bf6",
            cursor: "not-allowed",
            opacity: 0.6,
          }}
          className="pay-button"
          onClick={(e) => {
            e.preventDefault(); // Permanently disabled
          }}
          disabled={true}
        >
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={2}
          >
            <img src={fb}></img>
            {"Pay and Share to Facebook"}{" "}
          </Stack>
        </button>

        {/* Popup Modal */}
        {paymentStatus === "success" ? (
          <>
            <>
              {/* ///below comment code for success payment popup */}
              {/* <div>
                <img
                  style={{ justifySelf: 'center' }}
                  src={checkP}
                  alt="Check Payment"
                />
              </div>
              <h2 style={{ color: '#43d685' }}>Payment Successful</h2>
              <h1 style={{ color: '#9b9bb8' }}>
                You will receive a confirmation mail at
              </h1>
              <h1 style={{ color: 'black' }}>tonystark@pointbreak.com</h1>
              <h2>Total Amount: ₹{totalAmount.toFixed(2)}</h2>
                <div style={{ marginTop: '20px' }}>
            <button
              style={{ fontFamily: 'sfpromedium' }}
              onClick={closePopup}
            >
              Return to Home
            </button>
          </div>
               */}
            </>
          </>
        ) : (
          <div>
            {isPopupVisible && (
              <div
                className={`custom-popup-overlay ${
                  isPopupVisible ? "visible" : ""
                }`}
              >
                <div className="custom-popup-content">
                  {/* Close Button */}
                  <div
                    className="close-button"
                    onClick={closePopup}
                    title="Close"
                  >
                    ✖
                  </div>

                  <h1 className="popup-header">
                    <b>Uh Oh</b> ! Facebook allows only Verified Ad accounts to
                    receive Audiences
                  </h1>

                  {/* Horizontal Line with Extra Gap */}
                  <hr className="popup-divider" />

                  {/* Error Message */}
                  <p className="popup-message">
                    Unfortunately <strong>{paymentError}</strong> is not a
                    Verified Ad account ID. You can enter an alternate Ad
                    Account ID below.
                  </p>

                  {/* Input and Add Button */}
                  <div className="input-container">
                    <div style={{ flex: "1" }}>
                      <input
                        type="text"
                        placeholder="Enter Verified Ad Account ID"
                        value={InputAccountId || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value) && value.length <= 16) {
                            setInputAccountId(value); // Set the value in state
                            if (value === "") {
                              setErrorMessage(null); // Clear the error message when input is empty
                              setIsValidAdAccount(null);
                            }
                          }
                        }}
                        style={{
                          width: "100%",
                        }}
                      />

                      {/* Display error message below input if exists */}
                      {errorMessage && (
                        <p style={{ color: "red", marginTop: "5px" }}>
                          {errorMessage}
                        </p>
                      )}
                      {/* Display success message if Ad Account is valid */}
                      {isValidAdAccount && isValidAdAccount === true && (
                        <p style={{ color: "green", marginTop: "5px" }}>
                          Ad Account ID is valid. Please proceed to payment.
                        </p>
                      )}
                    </div>
                    <div>
                      <button
                        className="add-button"
                        onClick={() => {
                          if (InputAccountId) {
                            handleAdd(InputAccountId);
                          }
                        }}
                      >
                        ADD
                      </button>
                    </div>
                  </div>

                  {/* Tips Section */}
                  <div className="tips-section">
                    <p className="tips-message">
                      <strong>Tips for you 💡</strong>
                      <p className="popup-message">
                        You can follow the steps in the given{" "}
                        <a
                          href="https://www.facebook.com/business/help/2058515294227817?id=180505742745347"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "blue", textDecoration: "underline" }}
                        >
                          Link{" "}
                        </a>{" "}
                        to verify your existing Ad account.
                      </p>
                    </p>
                  </div>

                  {/* Footer Buttons */}
                  <div className="footer-buttons">
                    <button
                      className="contact-support-new"
                      onClick={() => {
                        if (!isLoading) apiContactUsApi(); // Only call handlePayClick if not loading
                      }}
                    >
                      Contact Support
                    </button>
                    <button
                      style={{ marginLeft: "20px" }}
                      className={`pay-button-new ${
                        !isValidAdAccount || isLoading ? "fade-out" : ""
                      }`}
                      onClick={() => {
                        if (!isLoading && isValidAdAccount) handlePayClick(); // Only call handlePayClick if not loading and account is valid
                      }}
                    >
                      Pay & Share Audience
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* {sessionStorage.getItem("isAlreadyPurchased") == "true" && (
          <Link
            href="/shiprocket_audience/dashboard"
            sx={{
              width: "100%",
              mt: 2,
            }}
          >
            <button
              style={{
                background: "#7f6bf6",
              }}
              className="pay-button"
            >
              Go to dashboard
            </button>
          </Link>
        )} */}
      </div>
    </>
  );
};

export default CartSummary;
const CouponCode: React.FC<CouponCode> = (props) => {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: props?.isApplicale ? "#9B9BB8" : "#EAEAEF",
        fontSize: "10px",
        padding: "5px 10px",
        borderRadius: 3,
        cursor: props?.isApplicale ? "pointer" : "not-allowed",
        background: props?.isActive ? "#d9d3ff" : "none",
      }}
      onClick={() =>
        props?.isApplicale ? props.setCurrCoupon(props.currItem) : null
      }
    >
      <Stack justifyContent={"space-between"} gap={2} direction={"row"}>
        <Typography fontSize={13}>{props.label}</Typography>
        {props.isActive && (
          <CloseIcon
            fontSize={"small"}
            onClick={(e) => {
              e.stopPropagation();
              props.onClose();
            }}
          />
        )}
      </Stack>
    </Box>
  );
};
